import React from 'react';
import Loader from "../components/Loader";
const LayoutLoader = () => {
    return (<div className="container-fluid"><Loader /></div>);
};
export default LayoutLoader;